export const withDecorators = (
  styles?: object,
  className?: string,
  decorators?: string[],
  extraClassName?: string
) => {
  var composedClassName = "";

  if (styles && className) {
    // @ts-ignore
    composedClassName += styles[className];

    if (decorators) {
      for (let i = 0; i < decorators.length; i++) {
        const decorator = decorators[i];

        if(decorator.length > 0){
          // @ts-ignore
          const decoratorStyles = styles[className + "_" + decorator];
          if (!decoratorStyles) {
            console.warn(`${className + "_" + decorator} not found in definition`);
          }
  
          composedClassName += ` ${decoratorStyles}`;
        }
        
      }
    }
  }

  if (extraClassName) {
    composedClassName += " " + extraClassName;
  }

  return composedClassName;
};
